<template>
  <div class="personal-container">
    <Header title="个人中心" />
    <div class="personal-inner">
      <el-card shadow="never">
        <template slot="header">
          <b>基本信息</b>
          <i class="el-icon-warning-outline"></i>
          <span>个人信息与其它数据密切关联，请勿随意修改</span>
        </template>
        <div class="content">
          <el-upload class="avatar-uploader" :data-user="['学生', '家长', '教职工', '管理员'][userInfo.userDict]" action="#"
            :http-request="requestUpload" :before-upload="beforeUpload" :show-file-list="false">
            <img :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../../assets/avatar.jpg')" width="150">
          </el-upload>
          <el-form label-width="75px" :model="userInfo" :rules="rules.userInfo" ref="userInfoForm">
            <el-form-item label="用户名" prop="name">
              <el-input size="medium" v-model="userInfo.name"></el-input>
            </el-form-item>
            <el-form-item label="登录名" prop="loginName">
              <el-input size="medium" v-model="userInfo.loginName"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
              <el-select size="medium" v-model="userInfo.gender">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="显示名" prop="displayName">
              <el-input size="medium" v-model="userInfo.displayName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input size="medium" v-model="userInfo.mobilePhone"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input size="medium" v-model="userInfo.cardNum"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="primary" @click="confirm('userInfo')">确认修改</el-button>
      </el-card>

      <el-card shadow="never">
        <template slot="header">
          <b>账号密码</b>
          <i class="el-icon-warning-outline"></i>
          <span>如忘记原始密码，请联系管理员重置密码</span>
        </template>
        <div class="content">
          <el-form :model="form" :rules="rules.password" ref="passwordForm">
            <el-form-item label="原始密码" prop="password">
              <el-input size="medium" type="password" show-password v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input size="medium" type="password" show-password v-model="form.newPassword"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input size="medium" type="password" show-password v-model="form.confirmPassword"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="primary" @click="confirm('password')">确认修改</el-button>
      </el-card>
    </div>
    <Footer />
    <el-dialog :visible.sync="dialogVisible" title="头像裁剪">
      <div class="cropper flex-column">
        <vueCropper ref="cropper" :img="option.img" :info="option.info" :outputType="option.outputType"
          :autoCrop="option.autoCrop" :canMove="option.canMove" :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" :centerBox="option.centerBox"
          @realTime="realTime" />
        <div class="tool">
          <el-button size="mini" icon="el-icon-refresh-left" @click="rotateLeft"></el-button>
          <el-button size="mini" icon="el-icon-refresh-right" @click="rotateRight"></el-button>
          <el-button size="mini" icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
          <el-button size="mini" icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
        </div>
      </div>
      <div class="preview flex-column">
        <div class="square">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
        <div class="circle">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="upload">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: 'Personal',
  components: {
    Header: () => import('../../components/Header'),
    Footer: () => import('../../components/Footer'),
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('请输入确认密码'))
      }
      callback()
    }
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      uploadParams: { token: localStorage.getItem('sys_token') },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputType: 'png', // 裁剪生成图片的格式
        autoCrop: true, // 是否默认生成截图框
        canMove: false, // 上传图片是否可以移动
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        centerBox: true, // 截图框是否被限制在图片里面
      },
      previews: {},
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        userInfo: {
          name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
          loginName: [{ required: true, message: '请输入登录名', trigger: 'change' }],
          gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
          displayName: [{ required: true, message: '请输入显示名', trigger: 'change' }]
        },
        password: {
          password: [{ required: true, message: '请输入原始密码', trigger: 'change' }],
          newPassword: [{ required: true, message: '请输入新密码', trigger: 'change' }],
          confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'change' }]
        }
      }
    }
  },
  methods: {
    beforeUpload(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png')
        return this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      if (file.size / 1024 / 1024 > 2)
        return this.$message.error('上传头像图片大小不能超过 2MB!')
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.option.img = reader.result
        this.loading = false
        this.dialogVisible = true
      }
    },
    requestUpload() { },
    upload() {
      this.$refs.cropper.getCropBlob(async data => {
        const file = new window.File([data], this.userInfo.name + '.png', { type: 'image/png' })
        const formData = new FormData()
        formData.append('file', file)
        const { data: { filePath } } = await api.upload(formData)
        this.userInfo.headUrl = filePath
        this.dialogVisible = false
      })
    },
    realTime(data) {
      this.previews = data
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    confirm(type) {
      if (type === 'userInfo') {
        this.$refs.userInfoForm.validate(async valid => {
          if (valid) {
            await api.updateUserInfo(this.userInfo)
            this.$message.success('已修改个人信息')
            this.getUserInfo()
          }
        })
      } else {
        this.$refs.passwordForm.validate(async valid => {
          if (valid) {
            await api.updatePassword(this.form)
            this.$message.success('已修改密码')
            this.$refs.form.resetFields()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-container {
  background: #f9fbfc;

  .personal-inner {
    height: 100vh;
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 100px 0 50px;
    display: flex;
    gap: 100px;

    ::v-deep.el-card {
      height: 100%;

      &__header {
        b {
          font-size: 18px;
        }

        i {
          font-size: 12px;
          margin: 0 3px 0 20px;
          color: #888;
        }

        span {
          font-size: 12px;
          color: #888;
        }
      }

      .content {
        display: flex;
        gap: 50px;
        padding: 20px 50px;
      }

      .avatar-uploader .el-upload {
        position: relative;
        height: 150px;
        overflow: hidden;

        &:hover::before {
          opacity: 1;
        }

        &::before {
          content: '更换头像';
          font-size: 13px;
          color: #fff;
          opacity: 0;
          inset: 0;
          background: #00000080;
          position: absolute;
          line-height: 150px;
          text-align: center;
          transition: 300ms;
        }
      }

      .avatar-uploader {
        position: relative;
        height: 150px;

        &::before {
          content: attr(data-user);
          font-size: 12px;
          font-weight: bold;
          position: absolute;
          bottom: -32px;
          left: 50%;
          transform: translateX(-50%);
          border: 1px solid #ddd;
          padding: 4px 10px;
          color: #888;
          background: #eee;
          border-radius: 2px;
        }
      }


      .el-input {
        width: 300px;
      }

      .el-button {
        float: right;
        width: 300px;
        margin-right: 50px;
      }
    }
  }

  ::v-deep.el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 50px;

    .cropper {
      width: 600px;
      height: 450px;
      gap: 10px;
    }

    .preview {
      gap: 50px;

      div {
        width: 180px;
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        &.circle {
          border-radius: 50%;
        }
      }
    }
  }
}
</style>